import React, { useEffect } from "react";

import i18n from "./i18n";
import Route from "./Routes";
import "./assets/scss/themes.scss";
import languages from "./common/languages";

function App() {
  useEffect(() => {
    configureLanguage(localStorage.getItem("lang") || "en");
  }, []);

  const configureLanguage = (lang) => {
    const html = window.document.documentElement;
    const langObj = languages[lang];
    html.lang = lang;
    html.dir = langObj.dir;
    i18n.changeLanguage(lang);
  };
  return (
    <React.Fragment>
      <Route />
    </React.Fragment>
  );
}

export default App;
